import * as Yup from 'common/yup';
import {passphrase} from 'common/yup/customs/passphrase';
import {diplomatObjectSchema} from './diplomat-object';
import {portSchema} from './transport/Abstract/AbstractServer';

export const emailSettingsSchema = diplomatObjectSchema.shape({
   outgoingServer: Yup.object({
      type: Yup.string(),
      address: Yup.string(),
      port: portSchema(),
      domain: Yup.string(),
      username: Yup.string(),
      directory: Yup.string(),
      timeout: Yup.number(),
      encryption: Yup.string(),
      fromField: Yup.string(),
      authentication: Yup.boolean(),
      delay: Yup.number(),
      maxSize: Yup.number(),
      password: passphrase(),
   }),
   incomingServer: Yup.object({
      type: Yup.string(),
      address: Yup.string(),
      port: portSchema(),
      domain: Yup.string(),
      username: Yup.string(),
      directory: Yup.string(),
      timeout: Yup.number(),
      encryption: Yup.string(),
      password: passphrase(),
   }),
   transSubjectTemplate: Yup.string(),
});

export type EmailSettings = Yup.InferType<typeof emailSettingsSchema>;
